import { MeasurementsQueryResult } from '../../../timeSeries/types'
import HighchartsChart from '@/components/Charts/HighchartsChart'
import { useParseLineChartOptions, TimeSeriesLineAreaRangeChartOptions } from './utils/parseLineChartOptions'
export type { TimeSeriesLineAreaRangeChartOptions }

interface TimeSeriesLineChartProps extends TimeSeriesLineAreaRangeChartOptions {
    series: MeasurementsQueryResult[]
    options?: TimeSeriesLineAreaRangeChartOptions
}

const LineChart: React.FC<TimeSeriesLineChartProps> = ({ series, options, disableLegend, ...highchartChartProps }) => {
    const parseLineChartOptions = useParseLineChartOptions({ ...options, disableLegend })

    return <HighchartsChart options={parseLineChartOptions(series)} {...highchartChartProps} />
}

export default LineChart
